<template>
  <svg
    width="121"
    height="132"
    viewBox="0 0 121 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="12.5"
      width="119"
      height="119"
      rx="7.5"
      fill="white"
    />
    <rect
      x="1"
      y="12.5"
      width="119"
      height="119"
      rx="7.5"
      stroke="#D6D3D1"
    />
    <rect
      x="8.5"
      y="20"
      width="104"
      height="12"
      rx="6"
      fill="#E7E5E4"
    />
    <rect
      x="8.5"
      y="44"
      width="32"
      height="12"
      rx="4"
      fill="#E7E5E4"
    />
    <rect
      x="44.5"
      y="44"
      width="32"
      height="24"
      rx="4"
      fill="#E7E5E4"
    />
    <rect
      x="8.5"
      y="100"
      width="32"
      height="24"
      rx="4"
      fill="#E7E5E4"
    />
    <rect
      x="44.5"
      y="114"
      width="32"
      height="10"
      rx="4"
      fill="#E7E5E4"
    />
    <rect
      x="80.5"
      y="72"
      width="32"
      height="24"
      rx="4"
      fill="#E7E5E4"
    />
    <rect
      x="4.5"
      y="44"
      width="108"
      height="80"
      fill="url(#paint0_linear_918_37846)"
    />
    <path
      d="M32.5 0.189453H36.5C38.6044 0.189453 40.3105 1.89557 40.3105 4V11.8105H28.6895V4C28.6895 1.89557 30.3956 0.189453 32.5 0.189453Z"
      fill="#E7E5E4"
      stroke="#D6D3D1"
      stroke-width="0.379169"
    />
    <path
      d="M84.5 0.189453H88.5C90.6044 0.189453 92.3105 1.89557 92.3105 4V11.8105H80.6895V4C80.6895 1.89557 82.3956 0.189453 84.5 0.189453Z"
      fill="#E7E5E4"
      stroke="#D6D3D1"
      stroke-width="0.379169"
    />
    <defs>
      <linearGradient
        id="paint0_linear_918_37846"
        x1="58.5"
        y1="44"
        x2="58.5"
        y2="124"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="white"
          stop-opacity="0"
        />
        <stop
          offset="1"
          stop-color="white"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
